<template>
  <b-row>
    <b-col cols="12">
      <b-card no-body class="border">
        <div v-if="requestPending" class="loading_page" style=" padding: 10px;">
          <orbit-spinner :animation-duration="1000" :size="60" :color="'#0e96b1'" />
        </div>

        <b-card-header class="p-1">
          <b-card-title class="font-medium-2">
            <feather-icon icon="LockIcon" size="18" />
            <span class="align-middle ml-50">{{ $t('Geofence Plans Permission') }}</span>
          </b-card-title>
        </b-card-header>

        <plans-filter :contract-filter.sync="contractFilter" :contract-options="contractsOptions"
          :owner-filter.sync="ownerFilter" :owners-options="ownersOptions">
        </plans-filter>

        <div class="m-2">
          <b-row>
            <b-col cols="12" md="6">
              <b-button type="submit" variant="primary" class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                :block="$store.getters['app/currentBreakPoint'] === 'xs'" @click="submit">
                {{ $t('Save Changes') }}
              </b-button>
            </b-col>
            <b-col cols="12" md="3" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
              <label>{{ $t('Show') }}</label>
              <v-select v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="perPageOptions"
                :clearable="false" class="per-page-selector d-inline-block mx-50" />
              <label>{{ $t('entries') }}</label>
            </b-col>

            <!-- Search -->
            <b-col cols="12" md="3">
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input v-model="searchQuery" class="d-inline-block mr-1" :placeholder="$t('Search')" />
              </div>
            </b-col>
          </b-row>

        </div>

        <div class="m-2">
          <b-table striped small responsive class="mb-0" :items="authPlans" :fields="fields">

            <template #head(list)="data">
              <b-form-checkbox v-model="isAllChecked" @change="checkAll(data, $event)" />
            </template>

            <template #cell(name)="data">
              {{ data.value }}
            </template>

            <template #cell(list)="data">
              <b-form-checkbox :state="userPlans.includes(data.item.id) ? true : null"
                               :checked="requestIds.includes(data.item.id)" @change="change(data, $event)" />
            </template>

          </b-table>
        </div>

        <div class="mx-2 mb-2">
          <b-row>

            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
              <span class="text-muted">
                {{ $t('Showing') }} {{ dataMeta.from }} {{ $t('to') }} {{ dataMeta.to }} {{ $t('of') }} {{ dataMeta.of }}
                {{ $t('entries plans') }}
              </span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">

              <b-pagination v-model="currentPage" :total-rows="totalTable" :per-page="perPage" first-number last-number
                class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
    </b-col>





  </b-row>
</template>

<script>
import {
  BFormFile,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BAlert,
  BCard,
  BCardText,
  BMedia, BPagination,
  BMediaAside,
  BMediaBody,
  BLink, BBadge,
  BImg,
  BTable, BFormCheckbox, BCardTitle, BCardHeader,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ref, watch } from '@vue/composition-api'
import store from '@/store'
import vSelect from 'vue-select'
import usePermissions from '@/views/modules/user/users-edit/permissions/usePermissions'
import PlansFilter from '@/views/modules/user/users-edit/permissions/PlansFilter'
import { OrbitSpinner } from 'epic-spinners'
import filters from '@/views/modules/Utils/filters'
import axios from '@/libs/axios'
import trans from '@/libs/i18n'

export default {
  components: {
    BButton, BForm, BImg, BFormFile,
    BFormGroup, BFormInput, BRow,
    BCol, BAlert, BCard, BCardText, BBadge,
    BMedia, BMediaAside, BMediaBody, vSelect, BPagination,
    BLink, BTable, BFormCheckbox, BCardTitle, BCardHeader, PlansFilter, OrbitSpinner
  },
  directives: {
    Ripple,
  },
  props: {
    user: {
      type: Number,
      required: true
    },
  },

  setup(props, { root }) {


    const fields = ['name', 'list']

    const isAllChecked=ref(false)
    const current_selected = ref([])
    const requestPending = ref(false)
    const authPlans = ref([])
    const userPlans = ref([])
    const requestIds = ref([])

    const ownerFilter = ref(null)
    const contractFilter = ref(null)

    const { ownersOptions, contractsOptions, contractsOptions_orig } = filters('plan')

    ///watch woner option refliter contracts
    const refliterContractByWoners = (owners) => {
      let result = contractsOptions_orig.value.filter((i) => owners == i.contractor_id)
      contractsOptions.value = result;
      if (owners == null) { contractsOptions.value = JSON.parse(JSON.stringify(contractsOptions_orig.value)); }
    }
    watch([ownerFilter], () => {
      refliterContractByWoners(ownerFilter.value)

    })
    /////end


    const { perPage, perPageOptions, searchQuery, currentPage, totalTable, dataMeta } = usePermissions()

    const filter = ref({})

    watch([currentPage, perPage, searchQuery, ownerFilter, contractFilter], () => {
      filter.value = {
        ...(searchQuery.value && { q: searchQuery.value }),
        ...(ownerFilter.value && { owner: ownerFilter.value }),
        ...(contractFilter.value && { contract: contractFilter.value })
      }
      // fetchAuthPlans()
    })


    const getUserPlans = async (id, callback) => {
      requestPending.value = true
      const response = await axios.get('userGetLinked', { params: { user: id, type: 'gplan' } })
      requestPending.value = false
      if (response.status === 200) {
        callback(response)
      }
    }

    getUserPlans(store.state.auth.userData.id, (r) => {
      const { total, data } = r.data
      totalTable.value = total
      authPlans.value = data
    })

    getUserPlans(props.user, (r) => {
      requestIds.value = r.data.data.map(p => p.id)
      userPlans.value = r.data.data.map(p => p.id)
      console.log(requestIds.value)
    })


    const checkAll = (data, value) => {
      if (value) requestIds.value = authPlans.value.map((v) => v.id)
      else requestIds.value = []
    }




    const submit = async () => {
      try
      {
        requestPending.value = true
        const payload = { user: props.user, type: 'gplan', ids: requestIds.value}
        const response = await axios.post('userLinkTo', payload)
        if (response.status === 200) {
          root.$root.$bvToast.toast(`${trans.t('successfully give permission to this user on geofence plans')}`, {
            title: `${trans.t('success')}`,
            variant: 'success',
            solid: true
          })
        }
      }

      catch (e)
      {
        if (e.response.status === 422) {
          root.$root.$bvToast.toast(`${trans.t('Error, Some data is missing')}`, {
            title: `${trans.t('Validation Error')}`,
            variant: 'danger',
            solid: true
          })
        }

        if (e.response.status === 500) {
          root.$root.$bvToast.toast(`${trans.t('Error, Server Error')}`, {
            title: `${trans.t('Error')}`,
            variant: 'danger',
            solid: true
          })
        }
      }

      requestPending.value = false


      //
      //      .then(res => {
      //    if (res.status === 200) {
      //
      //   }
      // }).catch(e => {
      //   if (e.response.status === 422) {
      //
      //   }
      //  }).finally(() => requestPending.value = false)

      //
      // requestPending.value = true
      // store.dispatch('app-permission/userLinkTo', {
      //   user: props.user,
      //   type: 'plan',
      //   ids: requestIds.value
      // }).then(res => {
      //
      //   requestPending.value = false
      //   toaster('Plans Updated Successfully', 'success', 'success')
      //   changedIds.value = []
      //   userPlans.value = requestIds.value.map(x => x)
      //   if(isAllChecked.value == true) {checkAll(undefined, true) }
      //
      // }).catch(reason => {
      //   requestPending.value = false
      //   toaster('Error Happened On Link Plans', 'error', 'Error')
      // })
    }

    const change = (data, value) => {
      const index = requestIds.value.indexOf(data.item.id);
      if (value && index === -1) requestIds.value.push(data.item.id)
      else requestIds.value.splice(index, 1)
    }


    return {
      authPlans,
      userPlans,
      perPage,
      perPageOptions,
      currentPage,
      searchQuery,
      totalTable,
      dataMeta,
      change,
      fields,
      submit,
      checkAll,
      isAllChecked,
      // fetchAuthPlans,

      ownersOptions,
      contractsOptions,

      ownerFilter,
      contractFilter,
      requestIds,
      requestPending,
      current_selected
    }
  },
}
</script>
